import { createVariant } from '../../utils/createVariant';
export const TooltipTitle = createVariant({
    name: 'tooltip-title',
    tagName: 'h6',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.heading7['75TooltipTitle']), { color: theme.colors.blanc.textTooltip })),
});
//# sourceMappingURL=TooltipTitle.js.map